<template>
    <div class="container">
        <ImagePreview ref="imagePreview" v-model="show" :images="images" :start-position="index" @change="selectImage($event)" lazyLoad :loop="false"></ImagePreview>
        <Navigation-bar type="dark" :title="`${index + 1}/${images.length}`">
            <YD-image src="icon/icon_nav_分享_白色" class="share" v-share="shareConfig"></YD-image>
        </Navigation-bar>
        <div class="thumb_mask" :class="{'hide': !isUnfold}"></div>
        <div class="thumb_box">
            <div class="action" @click="isUnfold = !isUnfold">
                <YD-image :src="isUnfold ? 'icon/icon_folding_down_1' : 'icon/icon_folding_up_1'"></YD-image>
            </div>
            <div class="thumb" :class="{'no-move': !isMove}" ref="thumb" v-show="isUnfold">
                <ul>
                    <li :class="{'active': i == index}" v-for="item,i in images" :key="i" ref="thumbLi">
                        <div class="img_box" @click="selectImage(i)">
                            <img :src="item" @error="imageError($event)">
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { ImagePreview } from 'vant';
import 'vant/lib/image-preview/style';
import appInteraction from '@/common/appInteraction';
export default {
    name: 'ImagePreview',
    components: {
        ImagePreview: ImagePreview.Component
    },
    data(){
        return{
            title: '',
            show: true,
            images: [],
            index: 0,
            isUnfold: true,
            thumbDom: null,
            thumbLi: null,
            thumbW: 0,
            ulW: 0,
            isMove: false,
            currentImgDom: null,
            timeOutEvent: null,
            touchstart: {},
        }
    },
    created(){
        this.title = decodeURIComponent(this.$route.query.name);
        let files = JSON.parse(sessionStorage.getItem('serial_match_file_12'));
        this.images = files.map(item=>item.store_path);
    },
    mounted(){
        this.thumbDom = this.$refs.thumb;
        this.thumbLi = this.$refs.thumbLi;
        this.initThumb();
    },
    computed: {
        shareConfig(){
            return {
                Type: 9,
                Title: this.title,
                Text: '',
                Link: 'https://m.dazhongyundong.com/app_download/',
                LinkText: '立即下载APP：',
                ImgLink: this.images[0]
            }
        }
    },
    methods: {
        imageError(ev){
            let parentNode = ev.target.parentNode;
            parentNode.removeChild(ev.target);
            parentNode.classList.add('van-image-preview__image');
            parentNode.innerHTML = '<i class="van-icon van-icon-photo-fail van-image__error-icon"></i>';
        },
        selectImage(index){
            this.thumbAn(index);
        },
        initThumb(){
            let thumbW = this.thumbDom.clientWidth;
            let ulW = thumbW / 7.5 * this.images.length;
            if(thumbW > ulW){
                this.isMove = false;
            }
            this.thumbW = thumbW;
            this.ulW = ulW;
            this.thumbAn(this.index);
        },
        //缩略图切换
        thumbAn(index){
            this.index = index;
            if(this.isMove){
                let currentDom = this.thumbLi[index];
                let left = currentDom.offsetLeft, width = currentDom.offsetWidth;
                let maxL = this.ulW - this.thumbW;
                if(this.thumbW / 2 < left + width / 2){
                    let MLeft = (left + width / 2) - (this.thumbW / 2);
                    this.thumbDom.scrollLeft = MLeft > maxL ? maxL : MLeft;
                }else{
                    let MLeft = (this.thumbW / 2) - (left + width / 2);
                    this.thumbDom.scrollLeft = MLeft > 0 ? 0 : MLeft;
                }
            }
            //处理图片未添加进dom
            setTimeout(()=>{
                this.imgAddEvent(index);
            }, 500)
        },
        //当前图片长按
        imgAddEvent(index){
            if(this.currentImgDom){
                let imgDom = this.currentImgDom;
                imgDom.removeEventListener('touchstart', this.operationEvent);
                imgDom.removeEventListener('touchmove', this.moveEvent);
                imgDom.removeEventListener('touchend', this.clearEvent);
            }
            let imgDom = this.$refs.imagePreview.$el.querySelectorAll('.van-swipe-item')[index].querySelector('.van-image img.van-image__img');
            if(imgDom){
                imgDom.addEventListener('touchstart', this.operationEvent);
                imgDom.addEventListener('touchmove', this.moveEvent);
                imgDom.addEventListener('touchend', this.clearEvent);
                this.currentImgDom = imgDom;
            }
        },
        operationEvent(e){
            if (e.touches.length > 1) {
                if (this.timeOutEvent) {
                    clearTimeout(this.timeOutEvent);
                }
                e.preventDefault();
                return;
            }
            this.touchstart = {
                pagex: e.touches[0].pageX,
                pagey: e.touches[0].pageY
            }
            this.timeOutEvent = setTimeout(()=>{
                appInteraction.share({
                    ...this.shareConfig,
                    ImgLink: this.images[this.index]
                });
            },700);
            e.preventDefault();
        },
        moveEvent(e){
            if (e.touches.length > 1) {
                clearTimeout(timeOutEvent);
                e.preventDefault();
                return;
            }
            let pageX = e.touches[0].pageX,
                pageY = e.touches[0].pageY;
            if(Math.abs(pageX - this.touchstart.pagex) > 5 || Math.abs(pageY - this.touchstart.pagey) > 5){
                clearTimeout(this.timeOutEvent);
            }
            e.preventDefault();
        },
        clearEvent(e){
            clearTimeout(this.timeOutEvent);
            e.preventDefault();
        }
    }
}
</script>
<style lang="scss" scoped>
    ::v-deep{
        .van-image-preview__overlay{
            background: #1B1C1E;
        }
        .van-image-preview{
            .van-image-preview__index{
                display: none;
            }
        }
    }
    .navigation_bar{
        z-index: 3000;
        background: linear-gradient(180deg, #1B1C1E 0%, rgba(27,28,30,0.96) 12%, rgba(27,28,30,0.92) 23%, rgba(27,28,30,0.88) 32%, rgba(27,28,30,0.83) 40%, rgba(27,28,30,0.78) 47%, rgba(27,28,30,0.73) 53%, rgba(27,28,30,0.67) 58%, rgba(27,28,30,0.61) 63%, rgba(27,28,30,0.53) 68%, rgba(27,28,30,0.45) 73%, rgba(27,28,30,0.36) 78%, rgba(27,28,30,0.25) 84%, rgba(27,28,30,0.13) 92%, rgba(27,28,30,0.00) 100%) !important;
    }
    .thumb_mask{
        height: 31%;
        min-height: calc(var(--safe-area-inset-bottom) + 248px);
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 3000;
        background-image: linear-gradient(180deg, rgba(27,28,30,0.00) 0%, rgba(27,28,30,0.13) 8%, rgba(27,28,30,0.25) 15%, rgba(27,28,30,0.36) 22%, rgba(27,28,30,0.45) 27%, rgba(27,28,30,0.53) 32%, rgba(27,28,30,0.61) 37%, rgba(27,28,30,0.67) 42%, rgba(27,28,30,0.73) 47%, rgba(27,28,30,0.78) 53%, rgba(27,28,30,0.83) 60%, rgba(27,28,30,0.88) 68%, rgba(27,28,30,0.92) 77%, rgba(27,28,30,0.96) 87%, #1B1C1E 100%);
        pointer-events: none;
    }
    .thumb_mask.hide{
        height: calc(var(--safe-area-inset-bottom) + 124px);
        min-height: calc(var(--safe-area-inset-bottom) + 124px);
    }
    .thumb_box{
        height: auto;
        width: 100%;
        position: fixed;
        bottom: calc(var(--safe-area-inset-bottom) + 40px);
        left: 0;
        z-index: 3000;
        .action{
            width: 48px;
            height: 48px;
            position: absolute;
            top: -88px;
            right: 34px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .thumb{
            height: 100px;
            width: 100%;
            overflow-x: auto;
            overflow-y: hidden;
            &.no-move{
                display: flex;
                justify-content: center;
            }
            ul{
                width: auto;
                height: 100%;
                display: inline-flex;
                white-space: nowrap;
                li{
                    flex: none;
                    width: 100px;
                    height: 100px;
                    border: 4px transparent solid;
                    box-sizing: border-box;
                    list-style: none;
                    vertical-align: middle;
                    &.active{
                        border-color: rgba(125,233,7,1);
                    }
                    .img_box{
                        width: 100%;
                        height: 100%;
                        background-color: #F2F2F2;
                        &.van-image-preview__image{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            ::v-deep .van-image__error-icon{
                                filter: contrast(0);
                            }
                        }
                        img{
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                }
            }
        }
    }
</style>